@if (branding()) {
  <mat-icon fontSet="zefplayer" [ngClass]="class">esko_menu</mat-icon>
} @else {
  <mat-icon fontSet="zefplayer" [ngClass]="class">zeffi_menu</mat-icon>
}
